async function copyText(text) {
  await navigator?.clipboard?.writeText(text);

  window.alert("복사 완료", text);
}

export default copyText;
